import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';

@Injectable({
  providedIn: 'root'
})
export class NoticeService {
  noticesList: AngularFireList<any>;
  eventsList: AngularFireList<any>;
  circularCmsList: AngularFireList<any>;
  newslettersList: AngularFireList<any>;

  constructor(private firebase: AngularFireDatabase) { }

  getNoticesList(): AngularFireList<any> {
    this.noticesList = this.firebase.list('notices');
    return this.noticesList;
  }

  getEventsList(): AngularFireList<any> {
    this.eventsList = this.firebase.list('events');
    return this.eventsList;
  }

  getCircularCmsList(): AngularFireList<any> {
    this.circularCmsList = this.firebase.list('circularcms');
    return this.circularCmsList;
  }

  getNewslettersList(): AngularFireList<any> {
    this.newslettersList = this.firebase.list('newsLetter');
    return this.newslettersList;
  }
}
